export default __webpack_public_path__ + "static/documents.administration-c15d3917b10505fa1c8c7f91bfc5be48.png";